module.exports = __webpack_public_path__ + "static/img-step-3@3x-dc614da941f899dc51cc81c854184d5b.png";